var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page2"},[_c('v-page-date',{on:{"changeData":_vm.changeData}}),_c('mr-echarts',{staticStyle:{"width":"100%","height":"80%"},attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }